import { render, staticRenderFns } from "./LinkFrame.vue?vue&type=template&id=038e6314&scoped=true&"
import script from "./LinkFrame.vue?vue&type=script&lang=js&"
export * from "./LinkFrame.vue?vue&type=script&lang=js&"
import style0 from "./LinkFrame.vue?vue&type=style&index=0&id=038e6314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e6314",
  null
  
)

export default component.exports